// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"8af020ca","429":"8af020ca"}[chunkId] + ".chunk.css";
};